"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Variant = void 0;
var Variant = exports.Variant = /*#__PURE__*/function (Variant) {
  Variant["DEFAULT"] = "default";
  Variant["TRANSPARENT"] = "transparent";
  Variant["TRANSPARENT_INVERSE"] = "transparentInverse";
  return Variant;
}({});